import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/archiveCard.module.css';

import type { IArchiveCard } from './types';

const ArchiveCard = ({
  backgroundColor = 'white',
  excerpt,
  eyebrow,
  resource,
  postTitle,
  url,
  ...props
}: IArchiveCard) => {
  
  return (
    <a className={styles[backgroundColor]}
      href={url}
      tabIndex={0}
      aria-label={postTitle}
      {...props}
    >
      <div className={styles.cardHeader}>
        <Icon className={styles.klaviyoFlag} iconName="BugMarkFilled"/>
        <div className={generateClassName(['eyebrow', styles.cardHeaderText])}>{resource}</div>
      </div>
      <div className={styles.postText}>
        <h3 className={generateClassName(['p1', 'semiBold', styles.postTitle])}>{postTitle}</h3>
        {excerpt && (
          <p className={generateClassName(['tagline', styles.postSubText])} dangerouslySetInnerHTML={{ __html: excerpt }}/>
        )}
      </div>
    </a>
  );
};

export default ArchiveCard;
